import React from "react";
import { Button, Box, Typography, Paper } from "@mui/material";
import { useSnackbar } from "./useSnackbar";

const SnackbarDemo = () => {
  const { showSuccess, showError, showWarning, showInfo, showCustom } =
    useSnackbar();

  const handleShowSuccess = () => {
    showSuccess("Operación completada exitosamente!");
  };

  const handleShowError = () => {
    showError("Ha ocurrido un error en la operación");
  };

  const handleShowWarning = () => {
    showWarning("Advertencia: Esta acción puede tener consecuencias");
  };

  const handleShowInfo = () => {
    showInfo("Información importante para el usuario");
  };

  const handleShowCustom = () => {
    showCustom("Mensaje personalizado con duración extendida", "info", {
      autoHideDuration: 10000,
      anchorOrigin: { vertical: "bottom", horizontal: "right" },
    });
  };

  return (
    <Paper sx={{ p: 3, m: 2 }}>
      <Typography variant="h6" gutterBottom>
        Demostración del Snackbar con Redux
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Este componente demuestra cómo usar el nuevo Snackbar que utiliza Redux
        para su gestión de estado.
      </Typography>

      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <Button
          variant="contained"
          color="success"
          onClick={handleShowSuccess}
          size="small"
        >
          Éxito
        </Button>

        <Button
          variant="contained"
          color="error"
          onClick={handleShowError}
          size="small"
        >
          Error
        </Button>

        <Button
          variant="contained"
          color="warning"
          onClick={handleShowWarning}
          size="small"
        >
          Advertencia
        </Button>

        <Button
          variant="contained"
          color="info"
          onClick={handleShowInfo}
          size="small"
        >
          Info
        </Button>

        <Button variant="outlined" onClick={handleShowCustom} size="small">
          Personalizado
        </Button>
      </Box>
    </Paper>
  );
};

export default SnackbarDemo;
